import { Box, Divider, Typography } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { ISharedPanel } from "source/models/panel/sharedPanel";
import { PageDrawer } from "source/components/framework/Page/PageDrawer";
import { AppChartIcon } from "source/components/framework/Icon/AppChartIcon";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";
import { ConfirmationButton } from "source/components/framework/Button/ConfirmationButton";

interface ISelectSharedPanelDrawerProps {
    companyId: string;
    title: string;
    sharedPanels: ISharedPanel[];
    onOk: (sharedPanel: ISharedPanel) => void;
    onCancel: () => void;
}

interface ISelectSharedPanelDrawerState {
    selectedId: string;
}

export const SelectSharedPanelDrawer = (props: ISelectSharedPanelDrawerProps) => {
    const [state, setState] = React.useState<ISelectSharedPanelDrawerState>({
        selectedId: ""
    });
    
    return (
        <PageDrawer
            open={true}
            icon={<AppChartIcon />}
            title={props.title}
            parentTitle={Translations.Panels}
            onClose={props.onCancel}
            fitToContainer
        >
            <VerticalContainer
                minHeight="100%"
                after={
                    <>
                        <Divider sx={{ margin: "1rem 0" }} />
                        <Box display="flex" justifyContent="flex-end" margin="1rem">
                            <AppButton variant="outlined" onClick={props.onCancel} sx={{ marginRight: ".5rem" }}>{Translations.Cancel}</AppButton>
                            <ConfirmationButton onClick={() => props.onOk(props.sharedPanels.find(p => p.id === state.selectedId))} disabled={!state.selectedId}>{Translations.Add}</ConfirmationButton>
                        </Box>
                    </>
                }
            >
                <Box display="flex" flexDirection="column" margin="24px" height="100%" overflow="auto">
                    {props.sharedPanels.map(panel => {
                        return <Box
                            key={panel.id}
                            onClick={() => setState(old => ({ ...old, selectedId: panel.id }))}
                            sx={{
                                borderRadius: ".5rem",
                                border: "1px solid",
                                borderColor: "divider",
                                backgroundColor: panel.id === state.selectedId ? "action.selected" : "action.hover",
                                marginBottom: "1rem",
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 0",
                                cursor: "pointer",
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                                <Box margin="0 8px" sx={{ color: panel.visible ? "text.secondary" : "text.disabled" }}>{panel.getIcon()}</Box>
                                <Typography sx={{ color: panel.visible ? "text.secondary" : "text.disabled" }}>{panel.id}</Typography>
                            </Box>
                        </Box>;
                    })}
                </Box>
            </VerticalContainer>
        </PageDrawer>
    );
};
